<template>
	<div id="multiselectlodgingservices">
		<div class="dropdown dropdown-filter" @click="showDropdown">
			<div class="overselect"></div>
			<div class="c-form-input">
				<h3 class="raleway-semi-p13">Équipements et services</h3>
				<img src="../../images/Fleche haut.svg" v-set-alt v-if="show" />
				<img src="../../images/flechebas-simple.svg" v-set-alt v-else />
			</div>
		</div>
		<div class="multiselect" v-if="show && servicesMount">
			<ul>
				<div class="row-selectoptions mt-3"  :class="{ row: !isPhone }">
					<div  :class="{ 'col-12': !isPhone }" v-for="(service, index) in sortedServices" :key="index">
						<li>
							<input
								type="checkbox"
								:id="service.name"
								:value="serviceSelectionValue(service)"
								v-model="selected"
							/>
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" :for="service.name">
								{{ formatService(service.name) }} <span class="filter-count">({{ getServiceCount(service) || 0 }})</span>
							</label>
						</li>
					</div>
				</div>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'multiselectlodgingservices',
		props: ['options', 'servicesMount', 'filterCounts'],
		data() {
			return {
				show: false,
				selected: [],
			};
		},
		methods: {
			showDropdown() {
				this.show = !this.show;
			},
			formatService(value) {
				return value.charAt(0).toUpperCase() + value.slice(1);
			},
			getServiceCount(service) {
				let count = 0;
				if (this.filterCounts) {
					if (this.filterCounts.service_ids && service.id) {
						const serviceData = this.filterCounts.service_ids.find(s => s.key === service.id);
						if (serviceData) count += serviceData.count;
					}
					if (this.filterCounts.service_entiers_ids && service.serviceEntierId) {
						const serviceEntierData = this.filterCounts.service_entiers_ids.find(s => s.key === service.serviceEntierId);
						if (serviceEntierData) count += serviceEntierData.count;
					}
				}
				return count;
			},
			serviceSelectionValue(service) {
				// Prefix selection values with source type to avoid id collisions between
				// service.id and serviceEntierId (same numeric id can exist for different names).
				if (service.id) return `service:${service.id}`;
				if (service.serviceEntierId) return `service_entier:${service.serviceEntierId}`;
				return null;
			},
		},
		watch: {
			selected(val) {
				const serviceIds = [];
				const serviceEntierIds = [];

				(val || []).forEach((selectionValue) => {
					if (typeof selectionValue !== 'string') return;

					const [selectionType, rawId] = selectionValue.split(':');
					const parsedId = Number(rawId);
					if (!parsedId) return;

					if (selectionType === 'service') {
						const item = this.servicesMount.find((s) => s.id === parsedId);
						if (item?.id) serviceIds.push(item.id);
						if (item?.serviceEntierId) serviceEntierIds.push(item.serviceEntierId);
					}

					if (selectionType === 'service_entier') {
						const item = this.servicesMount.find((s) => s.serviceEntierId === parsedId);
						if (item?.id) serviceIds.push(item.id);
						if (item?.serviceEntierId) serviceEntierIds.push(item.serviceEntierId);
					}
				});

				// Emit only real ids (no 0 placeholders) so the backend receives clean filters.
				this.$emit('checked', { serviceIds, serviceEntierIds }, 'services');
			},
		},
		computed: {
		sortedServices() {
			return [...this.servicesMount].sort((a, b) => {
			const nameA = a.name.toLowerCase();
			const nameB = b.name.toLowerCase();
			return nameA.localeCompare(nameB);
			});
		},
      isPhone() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          return true;
        } else {
          return false;
        }
      },
		},

	};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter">
.filter-count {
  color: #666;
  font-size: 0.9em;
  font-weight: normal;
  margin-left: 4px;
}
</style>
